import styled from "@emotion/styled";
import colors from "styles/colors";
import { WHITE_COLOR_NAME } from "styles/color-consts";
const BACKGROUND_COLOR = "#311cac";
const HOVER_BACKGROUND_COLOR = "#412cbf";
export const StyledContactSalesStickyButton = styled.div`
  transform: translateX(250px);
  transition: transform 0.3s ease-in-out;

  .contact-sales-sticky-button {
    width: 200px;
    padding: 18px 24px 18px 24px;
    color: ${colors[WHITE_COLOR_NAME]};
    background-color: ${BACKGROUND_COLOR};
    cursor: pointer;
    border-radius: 40px;
    margin-right: 24px;
    text-decoration: none;
    font-weight: 400;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid;
    border-color: ${WHITE_COLOR_NAME};

    .picture-component {
      display: flex;
      img {
        height: 24px;
      }
    }

    :hover {
      background-color: ${HOVER_BACKGROUND_COLOR};
    }

    will-change: transform;
  }

  &.is-visible {
    transform: translateX(0px);
  }
`;
